var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: _vm.loading } },
        [
          _c("contentTitle", {
            attrs: { label: "PARCEL COLLECTIONS", close: "routeClose" }
          }),
          _vm._v(" "),
          _c(
            "contentBody",
            { attrs: { locked: _vm.token === null, bg: "#f8f9fa" } },
            [
              _c(
                "ul",
                { staticClass: "collections-list list-group list-group-flush" },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer",
                      on: { click: _vm.routeUnlocked }
                    },
                    [
                      _vm._v("\n\t\t\t\t Unlocked Parcels "),
                      _c(
                        "span",
                        { staticClass: "badge badge-dark badge-pill" },
                        [_vm._v(_vm._s(_vm.unlockedLength))]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "material-icons md-18" }, [
                        _vm._v("lock")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.collections, function(row, index) {
                    return _vm.collections
                      ? _c(
                          "li",
                          {
                            key: row.id,
                            staticClass:
                              "list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer",
                            on: {
                              click: function($event) {
                                return _vm.routeCollection(row.id)
                              }
                            }
                          },
                          [
                            _vm._v("\n\t\t\t\t" + _vm._s(row.name) + " "),
                            _c(
                              "span",
                              { staticClass: "badge badge-dark badge-pill" },
                              [_vm._v(_vm._s(row.count || 0))]
                            ),
                            _vm._v(" "),
                            _c("i", { staticClass: "material-icons md-18" }, [
                              _vm._v("bookmarks")
                            ])
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  !_vm.addFormVisible
                    ? _c(
                        "li",
                        {
                          staticClass:
                            "list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer",
                          on: { click: _vm.addFormShow }
                        },
                        [
                          _vm._v("\n\t\t\t\tAdd Collection "),
                          _c("i", { staticClass: "material-icons md-18" }, [
                            _vm._v("add")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.addFormVisible
                ? _c(
                    "form",
                    {
                      staticClass: "category form-group p-3 bg-white",
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.addFormSubmit.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "category-title" }, [
                        _vm._v("NEW COLLECTION NAME")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "property-row" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.addFormRec.name,
                              expression: "addFormRec.name"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "is-invalid": _vm.error },
                          attrs: { type: "text", placeholder: "Enter a name" },
                          domProps: { value: _vm.addFormRec.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.addFormRec,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "invalid-feedback" }, [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(_vm.error) + "\n\t\t\t   "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "property-row" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-light",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.addFormHide.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-dark float-right",
                            attrs: { type: "submit" }
                          },
                          [_vm._v("Add")]
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b904f5e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b904f5e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collection/collection-list.vue
// module id = null
// module chunks = 